import React from 'react'
import './Feesandpayment.css'

export const Feesandpayment = () => {
  return (
    <div className="contentt-containerr">
      <div className="policycontent-container">
        {/* Payment of Tuition Fee via Bharat Kosh Section */}
        <div className="heading" style={{ marginTop: '40px' }}>
          <h2>Payment of Tuition Fee via Bharat Kosh</h2>
        </div>

        <div className="bharatkosh-content" style={{ paddingLeft: '70px' }}>
          <p>
            Tuition fees / Course Material Charges / Hostel Accommodation Charges can be paid online through the
            <strong> Bharat Kosh </strong> portal by selecting the appropriate ministry and purpose under the Quick Payment option.
          </p>

          <p><strong>The below mentioned steps are to be followed:</strong></p>

          <ol>
            <li>
              <strong>Access the Portal:</strong>
              <ol type="a">
                <li>Visit <a href="https://bharatkosh.gov.in/" target="_blank" rel="noopener noreferrer">https://bharatkosh.gov.in/</a></li>
              </ol>
            </li>

            <li>
              <strong>Choose Payment Mode:</strong>
              <ol type="a">
                <li>For one-time payment: Click on <strong>Quick Payment / Non-Registered Users</strong></li>
              </ol>
            </li>

            <li>
              <strong>Select Ministry and Purpose:</strong>
              <ol type="a">
                <li>Select <strong>"Individual"</strong> under the Depositor's category.</li>
                <li>Click on the search icon in Purpose and a Search Purpose dialogue box appears.</li>
                <li>Ministry: Choose the relevant ministry (e.g., <strong>SCIENCE & TECHNOLOGY</strong>).</li>
                <li>Click Search → Select Tuition Fee or equivalent from the purpose window.</li>
                <li>Enter the desired amount, remarks, and Captcha → Click on ADD → Next.</li>
              </ol>
            </li>

            <li>
              <strong>Enter Depositor Information:</strong>
              <ol type="a">
                <li>Full Name of Student or Guardian</li>
                <li>Email ID</li>
                <li>Mobile Number</li>
                <li>Address</li>
                <li>Select Online Payment / SWIFT / NEFT / RTGS</li>
                <li>Click Next</li>
              </ol>
            </li>

            <li>
              <strong>Select Payment Method:</strong>
              <ol type="a">
                <li>💳 Debit/Credit Card</li>
                <li>🏦 Net Banking</li>
                <li>📱 UPI</li>
                <li>🧾 NEFT/RTGS (CPIN will be auto-generated)</li>
              </ol>
            </li>

            <li>
              <strong>Review and Confirm:</strong>
              <ol type="a">
                <li>Double-check all entered details</li>
                <li>Proceed to payment gateway</li>
                <li>Complete the transaction</li>
              </ol>
            </li>

            <li>
              <strong>Download Receipt:</strong>
              <ol type="a">
                <li>Save or print the Transaction Receipt and Challan</li>
                <li>Submit to the institution if required</li>
              </ol>
            </li>
          </ol>

          <p><strong>Important Notes:</strong></p>
          <ol type="a">
            <li>For NEFT/RTGS, use the CPIN to complete the bank transfer; no need to update UTR manually.</li>
            <li>Always verify the correct ministry and purpose with your institution before making payment.</li>
            <li>Use the same email ID for future access to receipts or login recovery.</li>
          </ol>
        </div>

        {/* Mess Charges Section */}
        <div className="heading" style={{ marginTop: '40px' }}>
          <h2>Mess Charges</h2>
        </div>

        <div className="mess-details" style={{ paddingLeft: '70px' }}>
          <p>The Mess charges can be paid through the SB Account mentioned below:</p>
          <ol>
            <li><strong>Name of the Account Holder:</strong> BAIKURI SRINIVASULU (Mess Contractor)</li>
            <li><strong>Account Number:</strong> 6724056606</li>
            <li><strong>Type of Account:</strong> Saving Account</li>
            <li><strong>IFSC Code:</strong> IDBI000U029</li>
            <li><strong>MICR Code:</strong> 500019032</li>
            <li><strong>Bank Name:</strong> Indian Bank</li>
            <li><strong>Branch Name:</strong> Uppal</li>
            <li><strong>Branch Address:</strong> 2-1-32, Saraswathi Nagar, Nagole Road, Uppal, Hyderabad.</li>
          </ol>
        </div>
      </div>
    </div>
  )
}
